"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TBCalculator = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helpers_1 = require("../../helpers");
var TopiaInput_1 = require("../TopiaInput");
var react_1 = require("react");
var RealHourlyWageCalculator_1 = require("../RealHourlyWageCalculator");
function TBCalculator(_a) {
    var e_1, _b;
    var blok = _a.blok;
    var _c = __read((0, react_1.useState)(blok.formula.inputs), 2), state = _c[0], setState = _c[1];
    var stateValue = {};
    blok.formula.inputs.forEach(function (input) {
        stateValue[input.id] = input.defaultValue;
    });
    var keys = Object.keys(stateValue);
    var completedFormula = "";
    try {
        for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
            var input = keys_1_1.value;
            completedFormula += "let ".concat(input, " = ").concat(stateValue[input] || "0", ";\n");
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (keys_1_1 && !keys_1_1.done && (_b = keys_1.return)) _b.call(keys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    completedFormula += blok.formula.formula;
    var formulaResult = eval(completedFormula);
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex w-full flex-row justify-center bg-rgb-blue/20", children: (0, jsx_runtime_1.jsxs)("div", { className: "w-fit p-2", children: [(0, jsx_runtime_1.jsx)("h2", { className: "my-2 text-xl", children: blok.title ? blok.title : "Cashflow Calculator" }), (0, jsx_runtime_1.jsxs)("div", { className: "rounded-md bg-slate-600 p-2", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex  flex-col justify-center ", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-sm text-topia-gray", children: "Profit" }), (0, jsx_runtime_1.jsxs)("p", { className: "text-2xl font-bold text-future-blue", children: [(0, helpers_1.formatCurrency)(formulaResult), "/mo"] })] }), (0, jsx_runtime_1.jsx)("div", { className: "my-4 grid grid-cols-2 gap-4 md:flex md:flex-row  md:items-end", children: state.map(function (inputs, ix) {
                                if (inputs.defaultValue === "0") {
                                    setState(function (s) {
                                        s[ix].defaultValue = "";
                                        return __spreadArray([], __read(s), false);
                                    });
                                }
                                return ((0, jsx_runtime_1.jsx)("div", { className: "rounded-md  md:flex md:flex-col md:items-center", children: (0, jsx_runtime_1.jsx)(TopiaInput_1.TopiaTextInput, { label: inputs.label, inputProps: {
                                            value: inputs.defaultValue,
                                            onChange: function (ev) {
                                                setState(function (s) {
                                                    s[ix].defaultValue = ev.target.value;
                                                    return __spreadArray([], __read(s), false);
                                                });
                                            },
                                            type: "number",
                                        } }) }, inputs.id));
                            }) }), blok.include_real_hourly_wage && ((0, jsx_runtime_1.jsx)(RealHourlyWageCalculator_1.RealHourlyWageCalculator, { monthlyProfit: formulaResult }))] })] }) }));
}
exports.TBCalculator = TBCalculator;
